import { CostCenterEmployeeList } from 'modules/cost_centers/components/Resources/Employees/CostCenterEmployeeList'

const CostCentersPeoplePage = () => {
  return <CostCenterEmployeeList />
}

export default CostCentersPeoplePage
